import React from 'react';
import LegalPage from './LegalPage';

const PrivacyPolicy = () => (
  <LegalPage title="Privacy Policy" updated="23 June 2026">
    <p>
      ContextJet AI respects your privacy. This Privacy Policy explains how we
      collect, use, store, and protect information when you visit our website
      or engage us for services.
    </p>

    <h2>1. Business Information</h2>
    <ul>
      <li>Brand name: ContextJet AI</li>
      <li>Legal entity: ContextJetAi Services LLP</li>
      <li>Registered country: India</li>
      <li>Email: takeoff@contextjetai.services</li>
      <li>Website: https://www.contextjetai.services</li>
    </ul>

    <h2>2. Information We Collect</h2>
    <p>We may collect the following information:</p>
    <ul>
      <li>Name</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>Company name</li>
      <li>Project requirements</li>
      <li>Billing and invoice details</li>
      <li>Communication details shared through forms, email, calls, or messages</li>
      <li>Technical information required for project delivery</li>
      <li>Website usage data such as browser type, device type, pages visited, and basic analytics data</li>
    </ul>

    <h2>3. How We Use Information</h2>
    <p>We use collected information to:</p>
    <ul>
      <li>Respond to enquiries</li>
      <li>Prepare proposals and quotations</li>
      <li>Provide software development, AI, automation, and consulting services</li>
      <li>Manage client communication</li>
      <li>Create invoices and payment records</li>
      <li>Deliver and support projects</li>
      <li>Improve our website and services</li>
      <li>Comply with legal, tax, accounting, and regulatory obligations</li>
    </ul>

    <h2>4. Payment Information</h2>
    <p>
      Payments may be processed through third-party payment providers such as
      Razorpay or bank transfer systems. We do not store full card numbers or
      sensitive payment credentials on our website.
    </p>
    <p>
      Payment processing is handled by the relevant payment provider according
      to their own terms and privacy policy.
    </p>

    <h2>5. Sharing of Information</h2>
    <p>We do not sell personal information.</p>
    <p>We may share information only when necessary with:</p>
    <ul>
      <li>Team members and contractors involved in service delivery</li>
      <li>Cloud, hosting, analytics, or communication service providers</li>
      <li>Payment processors</li>
      <li>Legal, accounting, tax, or compliance advisors</li>
      <li>Government or regulatory authorities where required by law</li>
    </ul>

    <h2>6. Data Security</h2>
    <p>
      We take reasonable measures to protect client and website visitor
      information from unauthorised access, misuse, loss, or disclosure.
    </p>
    <p>
      However, no internet-based system is fully secure, and we cannot
      guarantee absolute security.
    </p>

    <h2>7. Data Retention</h2>
    <p>
      We retain information for as long as necessary to provide services,
      maintain business records, comply with legal obligations, resolve
      disputes, and enforce agreements.
    </p>

    <h2>8. International Clients</h2>
    <p>
      If you are located outside India and engage our services, your
      information may be processed in India or through third-party service
      providers used for project delivery.
    </p>

    <h2>9. Cookies and Analytics</h2>
    <p>
      Our website may use cookies or analytics tools to understand website
      performance and visitor behaviour. You may disable cookies in your
      browser settings.
    </p>

    <h2>10. Your Rights</h2>
    <p>
      You may contact us to request access, correction, or deletion of your
      personal information, subject to legal, contractual, and business record
      requirements.
    </p>

    <h2>11. Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. The updated version
      will be posted on this page with a revised date.
    </p>

    <h2>12. Contact</h2>
    <p>For privacy-related questions, please contact:</p>
    <ul>
      <li>Email: takeoff@contextjetai.services</li>
      <li>Website: https://www.contextjetai.services</li>
    </ul>
  </LegalPage>
);

export default PrivacyPolicy;
